import { config } from '../utils/config';

export const useConfig = () => {
  let baseUrl = config.baseUrl;
  let servicesUrl = config.servicesUrl;
  let panelUrl = config.panelUrl;
  let playgroundUrl = config.playgroundUrl;
  let statusPageURL = config.statusPageURL;
  let helpCenterURL = config.helpCenterURL;
  let discordUrl = config.discordUrl;
  let contactUsUrl = config.contactUsUrl;
  let docUrl = config.docUrl;
  let baseDomain = config.baseDomain;
  let feedbackFormURL = config.feedbackFormURL;
  let paypalClientId = config.paypalClientId;
  let paypalSandboxURL = config.paypalSandboxURL;
  let growthbookKey = config.growthbookKey;
  let featuresUpgrade = config.featuresUpgrade;
  let featuresSuggestion = config.featuresSuggestion;
  let featuresCtaReview = config.featuresCtaReview;
  let featuresCtaYoutubeSeo = config.featuresCtaYoutubeSeo;
  let featuresCtaYoutubeSuggestion = config.featuresCtaYoutubeSuggestion;
  let TransactionUrl = config.TransactionUrl;
  let paddleToken = config.PaddleToken;
  let paddleEnv = config.PaddleEnv;
  let stateProject = config.stateProject;
  let recaptchaSiteKey = config.recaptchaSiteKey;
  let assistantUrl = config.assistantUrl;
  let token = config.token();
  let lng = config.lng();
  let showSuggestion = config.show_suggestion();
  let resume_score_data = config.resume_score_data();
  let magical_resume_score_data = config.magical_resume_score_data();
  let top_keyword = config.top_keyword();
  let suggestion = config.suggestion();
  let youtubeTitle = config.youtubeTitle();
  let youtubeDescription = config.youtubeDescription();
  let youtubeHashtags = config.youtubeHashtags();
  let profile_data = config.profile_data();
  let resume_parser = config.resume_parser();
  let company_data = config.company_data();
  let expires_in = config.expires_in();
  let open_discord_modal = config.open_discord_modal();
  let close_second_navbar = config.close_second_navbar();
  let finish_stepper = config.finish_stepper();
  let show_upgrade_modal = config.show_upgrade_modal();
  let first_time_trial = config.first_time_trial();
  return {
    baseUrl,
    servicesUrl,
    token,
    discordUrl,
    lng,
    resume_score_data,
    magical_resume_score_data,
    top_keyword,
    suggestion,
    youtubeTitle,
    youtubeDescription,
    youtubeHashtags,
    profile_data,
    resume_parser,
    company_data,
    expires_in,
    open_discord_modal,
    close_second_navbar,
    panelUrl,
    finish_stepper,
    playgroundUrl,
    contactUsUrl,
    docUrl,
    baseDomain,
    paypalClientId,
    paypalSandboxURL,
    show_upgrade_modal,
    showSuggestion,
    growthbookKey,
    featuresUpgrade,
    featuresSuggestion,
    featuresCtaReview,
    featuresCtaYoutubeSeo,
    featuresCtaYoutubeSuggestion,
    TransactionUrl,
    paddleToken,
    paddleEnv,
    first_time_trial,
    stateProject,
    recaptchaSiteKey,
    statusPageURL,
    helpCenterURL,
    feedbackFormURL,
    assistantUrl,
  };
};
